module.exports = __webpack_public_path__ + "img/jas-logo-png-transparent.42d88d90.png";